import React, { useEffect, useState } from 'react';
import { format } from 'date-fns';
import { getResourceString } from '../../kentico/resource-strings';
import _ from 'lodash';
import { DateParser } from '@fnv-core/parsing/date/DateParser';
import { SummaryHelper } from '../helpers/SummaryHelper';
import { RenderStep } from '../components/FormControlRendering';
import { FormLogicHelper } from '../helpers/FormLogicHelper';
import { WidgetFormProps } from '../WidgetForm';
import { createPortal } from 'react-dom';
import { ValidationControlHelper } from '../helpers/ValidationControlHelper';
import ReactHtmlParser from "react-html-parser";
import { Steps } from '../../presentational/Steps';

const GezinslidmaatschapForm: React.FC<WidgetFormProps> = (state) => {

  const [contentData, setContentData] = useState<ContentData>(null);
  
  useEffect(() => {
    state.initForms(state.formDefinitions, false);

    const contentData: ContentData = {
      introText: state.props.summaryIntro
    };
    setContentData(contentData);
  }, []);
  
  if(state.fields.length > 0 && state.formLoading) {
    setTimeout(() => {
      state.setFormLoading(false);
    }, 1000);

    // get the invitation id from query params
    const queryParams = FormLogicHelper.getQueryParams();
    if(queryParams["id"]) {
      state.setFormData(prev => ({ ...prev, "UitnodigingID": { value: queryParams["id"], enabled: false, focus: false, loading: false, touched: false } as FormDataEntry }));
    }
  }

  const formSummaryData: FormSummaryData = {
    sections: [
      {
        title: getResourceString("Form.Gezinslidmaatschap.Summary.Label"),
        navigateToStep: 1,
        rows: [
          { 
            fieldName: "Voorletters", 
            visible: true 
          },
          {
            fieldName: "Naam",
            labelOverride: getResourceString("Form.Name.Label"),
            visible: true,
            dataOverride: (data, field) => `${state.formData["Voornaam"].value}${state.formData["Tussenvoegsel"]?.value ? 
              ` ${SummaryHelper.GetOptionLabelFromFieldByKeySummary(state.fields.find((f) => f["@column"] == "Tussenvoegsel"), state.formData["Tussenvoegsel"].value)} ` : 
              ""} ${state.formData["Achternaam"].value}`
          },
          {
            fieldName: "Geboortedatum",
            visible: true,
            dataOverride: (data, field) => format(new DateParser().parse(data), "dd-MM-yyyy")
          },
          { 
            fieldName: "Telefoonnummer", 
            visible: true 
          },
          { 
            fieldName: "GezinslidEmail", 
            visible: true 
          },
          {
            fieldName: "Adres",
            labelOverride: getResourceString("Form.Adres.Label"),
            visible: true,
            dataOverride: (data, field) => SummaryHelper.getAdresSummary("", state.formData, state.fields)
          }
        ]
      }
    ]
  };

  return (
    <div className='col-12 mijn-fnv__edit-page p-0' ref={state.formFieldsRef}>
      <>
        {/* Shows steps above the form */}
        {state.stepsContainerRef?.current &&
          createPortal(
          <>
            <Steps cssClass={""}
              steps={state.getFormSteps()}
              extraSteps={[]}
              activeStepFormName={state.currentStepIndex.toString()}>
            </Steps>
          </>,
          state.stepsContainerRef.current
        )}

        {state.beforeFormRef?.current && contentData?.introText &&
          createPortal(
          <>
            {state.currentStepIndex == 0 && (
              <div className="fnv-form-content fnv-form-content__container">
                {!ValidationControlHelper.isNullOrEmpty(contentData?.introText) && (
                  <p className="content__intro">{ReactHtmlParser(contentData.introText)}</p>
                )}
              </div>
            )}
          </>,
          state.beforeFormRef.current
        )}
        
        {!state.formLoading && (
          <>
            <RenderStep
              formDefinition={state.formDefinition}
              fields={state.fields}
              visibleFields={state.visibleFields} 
              currentStepIndex={state.currentStepIndex} 
              formData={state.formData} 
              setFormData={state.setFormData}
              formErrors={state.formErrors} 
              handleChange={state.handleChange} 
              handleBlur={state.handleBlur}
              formSummaryData={formSummaryData}
              navigateToStep={state.setHandleFormStepSpecific}
            />

            {/* Shows the navigation bar below the form (next/back/send) */}
            <state.FormNavigationBar />
          </>
        )}
      </>
    </div>
  );
};

export default GezinslidmaatschapForm;